import { useMutation } from "react-query";
import { AxiosError, AxiosResponse } from "axios";

import useAxios from "@src/config/axios/useAxios";
import { queryKeys } from "@src/config/queryKeys";
import { getTestBaseUrl } from "@src/config/baseUrls";

export interface ImagesRangeFormValues {
  start?: number;
  end?: number;
}

const useImagesRange = (studyId?: string, testId?: string) => {
  const axios = useAxios();

  return useMutation<AxiosResponse, AxiosError, ImagesRangeFormValues>(
    queryKeys.IMAGES_RANGE,
    (values) =>
      axios.put(
        `${getTestBaseUrl(studyId ?? "", testId ?? "")}/set-images-range`,
        values,
      ),
  );
};

export default useImagesRange;
